/*
 * Authors: mariushirjanu
 * Created: 13/10/2021
 */
import { Component, ElementRef, Input, OnInit } from '@angular/core';

@Component({
  selector: 'no-dialog-wrapper',
  template: `
    <ndc-dynamic [ndcDynamicComponent]="component" [ndcDynamicInputs]="inputs" [ndcDynamicOutputs]="outputs"></ndc-dynamic>
  `
})
export class NoDialogWrapperComponent implements OnInit {
  @Input() public component;
  @Input() public inputs;
  @Input() public outputs;
  @Input() public windowClass: string;

  constructor(
    private elementRef: ElementRef
  ) {
    /**/
  }

  public ngOnInit(): void {
    // add window class to parent element of this component
    $(this.elementRef.nativeElement).parents('modal-container')
      .addClass(this.windowClass);
  }
}